import { TypeIdSchema } from '@unipile/db';
import { Static, Type } from '@sinclair/typebox';
import {
  UNILOGIN_EXTENSION_CODE_PATTERN,
  UniLoginExtensionDownloadUrlsSchema,
  UniLoginExtensionStoreUrlsSchema,
} from './unilogin-hosted-auth.schema';

export const UniLoginAccountCheckpointSchema = Type.Object({
  object: Type.Literal('AuthenticationCheckpoint'),
  account_id: TypeIdSchema('account'),
  intent_id: TypeIdSchema('account'),
  checkpoint: Type.Object({
    type: Type.Literal('UNILOGIN'),
    extension_code: Type.String({ pattern: UNILOGIN_EXTENSION_CODE_PATTERN }),
    extension_code_expires_at: Type.String({ format: 'date-time' }),
    expires_at: Type.String({ format: 'date-time' }),
    extension_store_urls: UniLoginExtensionStoreUrlsSchema,
    extension_download_urls: UniLoginExtensionDownloadUrlsSchema,
  }),
});
export type UniLoginAccountCheckpoint = Static<typeof UniLoginAccountCheckpointSchema>;
